import { createAction, PayloadAction, createSlice } from '@reduxjs/toolkit'
import { PhoneSpecs } from '../phones'

export interface SearchState {
  downloadSpeed: number
}

export const searchSlice = createSlice({
  name: 'search',
  initialState: {} as SearchState,
  reducers: {
    prepareLaunch: (state: SearchState, action: PayloadAction<number>) => {
      state.downloadSpeed = action.payload
    },
  },
})

export type MobileSearchPayloadType = { phoneModelId?: PhoneSpecs['modelId'] } | undefined
export type InternetSearchPayloadType = { downloadSpeed: number }

export const launchMobileSearch = createAction<MobileSearchPayloadType>('search/launchMobileSearch')

export const launchInternetSearch = createAction<InternetSearchPayloadType>('search/launchInternetSearch')
